import React, { Component } from "react";

import logos from '../img/logos.jpg'
import YouTube from 'react-youtube'

class Inicio extends Component {
    constructor(props) {
        super(props)
    }

    render() {
        return (
            <>
                <section id="insideDoc">
                    <div id="acercade">
                        <h2>La méthode Mère Kangourou (MMK) sauve des vies dans le monde entier. Vous pouvez faire partie de cette aventure kangourou!</h2>
                        <p>Cette méthode, qui a commencé et a été développée en Colombie par des professionnels de la santé, est maintenant  reconnue internationalement  et  la Bibliothèque Cochrane  a publié en 2011 une révision qui montre que la MMK contribue à diminuer les taux de mortalité et morbidité  infantile. La méthode Mère Kangourou complémente les soins traditionnels donnés aux enfants prématurés et/ou de petit poids de naissance, et permet aux parents de jouer un rôle dans le processus de récupération physique et émotionnelle de leur enfant prématuré et/ou de petits poids de naissance. Cette méthode a également changé la pratique de la néonatalogie en la rendant plus  humaine et en intégrant les parents dans les soins de leur enfant fragile.</p>
                        <p>Ce Portail de Formation en MMK a été créé par des professionnels de la santé certifiés dans la connaissance et la pratique journalière de la Méthode Mère Kangourou et qui veulent contribuer à la diffusion efficace et rapide de la Méthode dans le monde entier en partageant cette connaissance avec leurs collègues du monde entier. Allez à « Créer un compte » pour vous inscrire, c’est gratuit et vous donnera accès à tout le matériel utilise par la « FundacionCanguro », ONG colombienne sans but lucratif  qui travaille depuis plus de 20 ans dans l’évaluation et la diffusion de la MMK.</p>
                        <p>Si vous n’êtes pas encore certifié en MMK, nous vous invitons à faire partie de cette grande communauté virtuelle, vous pouvez nous écrire en allant à « Nous contacter » pout vous renseigner et vous tenir au courant. Envoyez-nous vos commentaires, la Colombie et le monde entier ont besoin de gens comme vous, intéressés par la MMK et avec une grande sensibilité envers ces bébés si fragiles.</p>

                        <YouTube videoId="ukSY6CgZhFU" />

                        <img height="80" src={logos}></img>
                    </div>
                </section>
            </>
        )
    }
}

export default Inicio